import Box from "@nexthink/apollo-components/lib/components/box/Box";
import { apolloSpaceInline1X } from "@nexthink/apollo-components/lib/tokens";
import { getValueFromPixelString } from "@nexthink/apollo-components/lib/utils/TokenHelpers";
import styled from "styled-components";

export const StyledMenuGroupContainer = styled(Box)<{ level: number }>(({ level }) => ({
  paddingLeft: level * getValueFromPixelString(apolloSpaceInline1X),
}));
